<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item  prop="title" label="考核标题">
                    <el-input v-model="form.title" placeholder="请输入考核标题" maxlength="100" style="width:260px;"></el-input>
                </el-form-item> 

                <el-form-item  prop="startYear" label="开始年份">
                    <el-date-picker style="width:260px;"
                        v-model="form.startYear"
                        type="year"
                        placeholder="选择开始年份"
                        value-format="yyyy">
                    </el-date-picker>
                </el-form-item>

                <el-form-item  prop="endYear" label="结束年份">
                    <el-date-picker style="width:260px;"
                        v-model="form.endYear"
                        type="year"
                        placeholder="选择结束年份"
                        value-format="yyyy">
                    </el-date-picker>
                </el-form-item>

                <el-form-item  prop="companyName" label="制定者">
                    <el-input v-model="form.companyName" placeholder="请输入某某局制定" maxlength="100" style="width:260px;"></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    deptId:"",
                    title:"",
                    startYear: "",
                    endYear: "",
                    companyName: "",
                },
                rules: {
                    title: [
                        { required: true, message: '请输入考核标题', trigger: 'blur' }
                    ],
                    startYear: [
                        { required: true, message: '请选择开始年份', trigger: 'blur' }
                    ],
                    endYear: [
                        { required: true, message: '请选择结束年份', trigger: 'blur' }
                    ],
                    companyName: [
                        { required: true, message: '请输入制定者', trigger: 'blur' }
                    ],
                },
                // pickerOptions: {
                //     disabledDate(time) {
                //         return time.getTime() < Date.now() - 8.64e7;
                //     }
                // }
            }
        },
        components: {
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId=deptId;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
 
                        let url= this.teacherTemplateSaveUrl;
                        let data = {
                            deptId:this.form.deptId,
                            title:this.form.title,
                            startYear:this.form.startYear,
                            endYear:this.form.endYear,
                            companyName:this.form.companyName
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            },
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/template/AddTemplate.vue